<template>
  <router-link
    :to="localizedRoute(link)"
    class="nav-link no-underline"
  >
    <span class="nav-link-text cl-white">
      <slot>{{ text }}</slot>
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'NavLink',
  props: {
    link: {
      type: [Object, String],
      required: true
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

$color-partner: color(partner);

.nav-link {
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
  background-color: $color-partner;
  padding: 0.5rem 1rem;
  transition: opacity .15s ease-in-out;
  &:hover,
  &:focus {
    opacity: 0.8;
  }
}

.nav-link-text {
  white-space: nowrap;
  font-family: inherit;
  font-size: inherit;
  font-weight: bolder;
}
@media (max-width: 767px) {
  .nav-link-text {
    font-size: 12px;
  }
}
</style>
